import Select from "./Select";
import { SelectProps, SelectSingleProps, SelectMultiProps, SingleSelectOption } from "./ISelect";

export type { SelectProps, SelectSingleProps, SelectMultiProps, SingleSelectOption };
export default Select;
